import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_wrkrs_forced_to_work_overtime_und_threat_of_penalty'

export const dataPointDefinition = {
  retracedId: 'are_wrkrs_forced_to_work_overtime_und_threat_of_penalty',
  name: 'Are workers forced to work overtime under threat of penalty?',
  description:
    'This question covers 3 possible overtime scenarios. Answer Yes if all elements are found for any of the 3 scenarios. For each scenario, consider workers vulnerability in determining whether they freely agreed to work the overtime. Threats can be communicated verbally or through other means, for example, by punishing a worker to set an example for others. \r\r\n\r\r\nIf workers are forced to work overtime in order to earn minimum wage, Answer "Yes" IF:\r\r\n- workers have no real choice but to work the overtime (involuntary), AND\r\r\n- workers are under the menace of a penalty (e.g., termination, removal of rights or privileges, etc.)\r\r\n\r\r\nIf workers are forced to work overtime in order to meet production targets, Answer "Yes" IF:\r\r\n- workers must work without pay in order to reach production targets (involuntary), AND\r\r\n- workers are under the menace of a penalty (e.g., termination)\r\r\n\r\r\nIf workers are forced to work excessive overtime (beyond legal limits), Answer "Yes" IF:\r\r\n- the number of overtime hours worked exceeds legal limits, AND\r\r\n- workers have not freely agreed to work the excessive overtime; AND\r\r\nthere is economic compulsion, such as threats to fire workers or never offer them overtime again.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fl-7--1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 7000,
  sectionId: '2.2.7',
  impactArea: 'Forced Labour',
  impactAreaId: 'FORCED_LABOUR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
